import React from 'react'
import { useProducts } from '../../context'

export const ProductsLoadingIndicator: React.FC = () => {
  const { productsLoading } = useProducts()

  if (!productsLoading) return null

  return <div className="productlist-loading" id="Loading" />
}
